import script from "./manufacturer.vue?vue&type=script&setup=true&lang=ts"
export * from "./manufacturer.vue?vue&type=script&setup=true&lang=ts"

import "./manufacturer.vue?vue&type=style&index=0&id=4889cd55&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4889cd55"]])

export default __exports__